exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table th[data-v-8f10c20e] {\n    text-transform: none;\n}\n.stat-ctn[data-v-8f10c20e] {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n. icon-letter[data-v-8f10c20e] {\n    border-radius: 50px;\n    width: 28px;\n    height: 28px !important;\n    padding: 0;\n}\n", ""]);

// exports
